import { LuxKitModalBehaviourDispatchContext } from 'LuxKit/Modal/context/LuxKitModalBehaviourContexts'
import { LuxKitModalBehaviourDispatchActions } from 'LuxKit/Modal/context/LuxKitModalBehaviourState'
import useScrollEndsObserver from 'hooks/useScrollEndsObserver'
import { stopPropagation } from 'lib/web/eventHandlerUtils'
import type { PropsWithChildren } from 'react'
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef } from 'react'
import styled from 'styled-components'

const StyledModalBody = styled.div`
  overflow-y: auto;
  height: 100%;
`

const OfferComparisonModalBody = forwardRef<HTMLDivElement, PropsWithChildren<{}>>((props, ref) => {
  const {
    children,
  } = props

  const modalBehaviourDispatch = useContext(LuxKitModalBehaviourDispatchContext)

  const bodyRef = useRef<HTMLDivElement | null>(null)

  const {
    hasReachedVerticalEnd,
    hasReachedVerticalStart,
  } = useScrollEndsObserver(bodyRef, children)

  useImperativeHandle(ref, () => bodyRef.current!)

  useEffect(() => {
    modalBehaviourDispatch({
      type: LuxKitModalBehaviourDispatchActions.TOGGLE_BODY_HAS_REACHED_END,
      hasReached: hasReachedVerticalEnd,
    })
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [hasReachedVerticalEnd])

  useEffect(() => {
    modalBehaviourDispatch({
      type: LuxKitModalBehaviourDispatchActions.TOGGLE_BODY_HAS_REACHED_START,
      hasReached: hasReachedVerticalStart,
    })
  }, [modalBehaviourDispatch, hasReachedVerticalEnd, hasReachedVerticalStart])

  return <StyledModalBody ref={bodyRef} onClick={stopPropagation}>
    {children}
  </StyledModalBody>
})

OfferComparisonModalBody.displayName = 'OfferComparisonModalBody'

export default OfferComparisonModalBody
